<template>
  <div class="infoAboutActionLog">
    <span class="title">{{ $t('fullHistory') }}</span>
    <div
      class="infoAboutActionLog-container"
      v-for="(actionsLog, index) in activeReservations.actionsLog"
      :key="index"
    >
      <div class="info" v-if="actionsLog.assignedTime">
        <p>{{ $t('assignedTime') }}</p>
        <span> {{ dateTime(actionsLog.assignedTime) }} </span>
        <span v-if="actionsLog.assignedUserName">
          ( {{ actionsLog.assignedUserName }} )
        </span>
      </div>
      <div class="info" v-if="actionsLog.deleteTime">
        <p>{{ $t('deleted') }}</p>
        <span> {{ dateTime(actionsLog.deleteTime) }} </span>
        <span v-if="actionsLog.deleteUserName">
          ( {{ actionsLog.deleteUserName }} )
        </span>
      </div>
      <div class="info" v-if="actionsLog.lockerId">
        <p>{{ $t('lockerID') }}</p>
        <span> {{ actionsLog.lockerId.join(', ') }} </span>
      </div>
      <div class="info" v-if="actionsLog.reservedUserId">
        <p>{{ $t('reserved') }}</p>
        <span>
          {{
            actionsLog.reservedUserId === 'API'
              ? 'API'
              : actionsLog.reservedUserName
          }}
        </span>
      </div>
      <div
        class="infoUpdatesLog"
        v-for="(updatesLog, index) in actionsLog.updatesLog"
        :key="index"
      >
        <div class="info" v-if="updatesLog">
          <p>{{ $t('deliveryHistoryPage.updated') }}</p>
          <span> {{ dateTime(updatesLog.updateTime) }} </span>
          <span v-if="updatesLog.updateUserName">
            ( {{ updatesLog.updateUserName }} )
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'InfoAboutActionLog',
  props: ['activeDelivery'],
  methods: {
    dateTime(value: number) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    }
  }
})
export default class InfoAboutActionLog extends Vue {}
</script>

<style lang="scss" scoped>
.infoAboutActionLog {
  margin-top: 24px;
  .title {
    font-family: 'Ubuntu-Medium';
    font-size: $eighteenSize;
    line-height: 15px;
  }
  .infoAboutActionLog-container {
    display: flex;
    flex-direction: column;
    height: 100px;
    padding: 16px;
    border: 1px solid $border;
    background-color: $light-grey;
    border-radius: 8px;
    margin-top: 23px;
    overflow-y: scroll;
    .info {
      margin-bottom: 25px;
      background-color: $light-grey;
      p {
        color: $label;
        line-height: 14px;
        font-size: $twelveSize;
        background-color: $light-grey;
      }
      span {
        color: $mid-grey;
        line-height: 14px;
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .infoUpdatesLog {
      margin-bottom: 25px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
